import React from "react";
import { useTranslation } from "react-i18next";
import tw, { css } from "twin.macro";

import SearchIcon from "../../../static/icons/search.svg";
import MaterialSourcingIcon from "../../../static/images/material-sourcing.svg";
import Anchor from "../../components/Anchor";
import { BookMeeting } from "../../components/BookMeeting";
import Card from "../../components/Card";
import { Container } from "../../components/Container";

const searchCards = css`
  ${tw`mx-auto mt-10 md:w-[50rem]`}
  >a:not(:first-of-type) {
    ${tw`pt-10 sm:pt-0`}
  }
  > a {
    ${tw`w-full p-0 text-turquoise w-full hover:(text-turquoise-dark) sm:max-w-[19.9rem]`}
    >div {
      ${tw`hover:shadow-xl motion-safe:hover:scale-105 h-full sm:mt-[50px] rounded-[4rem] max-h-[25rem]`}
    }
  }
  p,
  .cardContent {
    ${tw`mt-2 mb-2 text-xl`}
    >p {
      ${tw`mt-8`}
    }
    > div {
      > p {
        ${tw`flex inline-flex`}
      }
      > svg {
        ${tw`w-10 h-10 mx-auto mt-2`}
      }
    }
  }
  svg {
    ${tw`mx-auto fill-current`}
    >g {
      ${tw`stroke-current`}
    }
  }
`;

const MaterialProcessing: React.FC = ({ ...rest }) => {
  const { t } = useTranslation();

  return (
    <Container {...rest}>
      <section>
        <article>
          <h2>{t("index.materialProcessing.header")}</h2>
          <p tw="mt-10 font-bold text-xl">{t("index.materialProcessing.learnMore")}</p>
          <div css={searchCards}>
            <Anchor href={"/material-sourcing"}>
              <Card key={3}>
                <MaterialSourcingIcon tw="w-40 h-40" />
                <div tw="flex flex-col items-center w-auto">
                  <p tw="break-normal">{t("index.searchButtons.materialSourcing")}</p>
                  <SearchIcon tw="w-10 h-10" />
                </div>
              </Card>
            </Anchor>
          </div>

          <p tw="mt-10 sm:mt-20 text-xl">{t("index.materialProcessing.findBestTechnology")}</p>
          <p tw="mt-10 font-black text-2xl sm:text-4xl">{t("index.materialProcessing.outro")}</p>
          <BookMeeting commentFirst={true} />
        </article>
      </section>
    </Container>
  );
};

export default MaterialProcessing;
